import { IonContent, IonPage } from "@ionic/react";
import { withRouter } from "react-router";
import HeaderAsignacion from "src/components/asignacion/HeaderAsignacion";
import { AsignacionProps } from "src/utils";
import { closeOutline } from "ionicons/icons";
import AcordAsignacion from 'src/components/asignacion/acordiones/AcordAsignacion'


const AsignacionDTEdicion: React.FC<AsignacionProps> = (
  props: AsignacionProps
) => {
  const history = props.history;

  const botonCerrar = {
    icono: closeOutline,
    action: () => history.goBack(),
  };

  return (
    <IonPage>
      <HeaderAsignacion botonIzq={botonCerrar} titulo="Detalles" />
      <IonContent id="asignacion">
        <div className="container">
          <div className="d-flex mt-3 flex-column align-items-center">
          
            <AcordAsignacion/>
            
            <div style={{display:'flex'}}> 

            </div>
            
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(AsignacionDTEdicion);
